var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2363 17.0975L9.5999 16.4611L8.96351 17.0975C9.31498 17.449 9.88483 17.449 10.2363 17.0975ZM9.5999 15.1883L5.4363 11.0247C5.08483 10.6732 4.51498 10.6732 4.16351 11.0247C3.81203 11.3762 3.81203 11.946 4.16351 12.2975L8.96351 17.0975L9.5999 16.4611C10.2363 17.0975 10.2362 17.0975 10.2363 17.0975L19.4973 7.83646C19.8488 7.48499 19.8488 6.91514 19.4973 6.56367C19.1458 6.21219 18.576 6.21219 18.2245 6.56367L9.5999 15.1883Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.4c831bb5f403798667a99aaaa4e7dfe3.svg";
export { ForwardRef as ReactComponent };